import ResponseHandler from './ResponseHandler';

export default ResponseHandler;
